import React, {Component} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../../../styles/Tabs.css'
import Cennik from "./cennikComponents/Cennik";
import WyszukiwarkaService from "../../WyszukiwarkaService";

export default class ShowCennik extends Component {

    constructor(props) {
        super(props);

        this.state = {
            jednorazoweOne: [],
            jednorazoweTwo: [],
            miesieczneOne: [],
            miesieczneTwo: [],
            tabIndex: 0,
            loader: true
        }
    }

    //idKu, idKuPrze, idMiOd, idMiPrze, idMiDo, idTr, idTrPrze
    componentDidMount() {

        console.log(this.props);

        let mW = this.props.item.idMiOd;
        let mD = this.props.item.idMiDo;

        if (this.props.powrotny) {
            mW = mD;
            mD = mW
        }

        if (this.props.item.idTrPrze !== null) {
            WyszukiwarkaService.getZnizkiCennik(this.props.item.idKu, this.props.item.idKuPrze, mW, 79, mD, this.props.item.idTr, this.props.item.idTrPrze)
                .then(function (response) {

                    let miesieczneOne = response.data.miesieczne[0].filter((item)=> item.rodz !== "ZSPEC")
                    let miesieczneTwo = response.data.miesieczne[1].filter((item)=> item.rodz !== "ZSPEC")

                    this.setState({
                        jednorazoweOne: response.data.jednorazowe[0],
                        jednorazoweTwo: response.data.jednorazowe[1],
                        miesieczneOne: miesieczneOne,
                        miesieczneTwo: miesieczneTwo,
                        loader: false
                    });
                    console.log(response.data)
                }.bind(this)).catch(err => {
                console.log(err);
            });
        } else {
            WyszukiwarkaService.getZnizkiCennik(this.props.item.idKu, null, mW, mD, 79, this.props.item.idTr, null)
                .then(function (response) {

                    let miesieczneOne = response.data.miesieczne.filter((item)=> item.rodz !== "ZSPEC")

                    this.setState({
                        jednorazoweOne: response.data.jednorazowe,
                        miesieczneOne: miesieczneOne,
                        loader: false
                    })
                }.bind(this)).catch(err => {
                console.log(err);
            });
        }
    }

    render() {
        return <div>

            <hr style={{borderTop: '2px solid #57b13caa'}}/>
            {this.state.loader ? <div>
                    <div className="loaderDim"
                         style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> :
                <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({tabIndex})}>
                    <TabList>
                        <Tab>Bilety jednorazowe</Tab>
                        <Tab>Bilety miesięczne</Tab>
                    </TabList>
                    <TabPanel style={{width: '90%', margin: '0 auto', fontSize: '0.875rem'}}>
                        <Cennik item={this.props.item} biletyOne={this.state.jednorazoweOne}
                                biletyTwo={this.state.jednorazoweTwo}/>
                    </TabPanel>
                    <TabPanel style={{width: '90%', margin: '0 auto', fontSize: '0.875rem'}}>
                        <Cennik item={this.props.item} biletyOne={this.state.miesieczneOne}
                                biletyTwo={this.state.miesieczneTwo}/>
                    </TabPanel>
                </Tabs>}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/wyszukiwarkaComponents/szczegolyComponents/ShowCennik.js